import { ListType } from 'modules/domains/list';
import { useCallback, useMemo } from 'react';
import { BUTTON_SIZES } from 'ui/button/constants';
import { ButtonGroup } from 'ui/buttonGroupV2/ButtonGroup';
import { BUTTON_GROUP_TYPES } from 'ui/buttonGroupV2/types';
import { isValidEnumValue } from 'utils/tsHelpers';
import { DEFAULT_LIST_TYPE_FILTER, LIST_TYPE_FILTERS } from '../constants';
import { useFilterContext } from '../contexts/FilterContext';
import { useQueryContext } from '../contexts/QueryContext';

export const DATA_TEST = {
  buttonGroup: 'table-filter-buttons',
};

export const FiltersToolbar = () => {
  const { type, setType } = useFilterContext();
  const { listCountByType } = useQueryContext();

  const handleChange = useCallback(
    (selection: string) => {
      setType(isValidEnumValue(selection, ListType) ? selection : null);
    },
    [setType],
  );

  const buttonOptions = useMemo(
    () =>
      LIST_TYPE_FILTERS.map((filterType) => ({
        id: filterType,
        'data-test': `tableFilterButton-${filterType}`,
        children: `${filterType}${listCountByType[filterType] ? ` (${listCountByType[filterType]})` : ''}`,
        onClick: () => handleChange(filterType),
      })),
    [listCountByType, handleChange],
  );

  return (
    <ButtonGroup
      data-test={DATA_TEST.buttonGroup}
      defaultSelectedIds={[type ?? DEFAULT_LIST_TYPE_FILTER]}
      description="Filter lists by type"
      options={buttonOptions}
      size={BUTTON_SIZES.LARGE}
      type={BUTTON_GROUP_TYPES.SINGLE_SELECT}
    />
  );
};
